module.exports = __webpack_public_path__ + "img/logo_circle_white.ab2ba5b4.png";